import React, { useEffect, useState } from "react";
import GymshimLogo from '../../assets/gymshim-logo-icon.png';
import GymshimLogoFull from '../../assets/gymshim-logo.png'; 
// import config from "../../config";
import client from "../../clients";
import { isAuthenticated, SignOut } from "../../auth";
import './style.scss';
import GymFilter from "../gym-filter";
import BrandFilter from "../brand-filter";
import { useHistory } from "react-router-dom/cjs/react-router-dom";


const GlobalHeader = (props) => {

  const history = useHistory();
  const { user, token } = isAuthenticated();
  const [isProfileViewOpen, setProfileViewOpen] = useState(false);
  // const [selectedGym, setSelectedGym] = useState("");

  const handleSelectedGym = (selectedGym) => {
    if(props.finalSelectedGym){
      props.finalSelectedGym(selectedGym);
    }
  }

  const handleSelectedBrand = (selectedBrand) => {
    if(props.getSelectedBrand){
      props.getSelectedBrand(selectedBrand);
    }
  }

  const toggleProfileView = () => {
    setProfileViewOpen(!isProfileViewOpen)
  }
  
  const handleSignOut = () => {
    SignOut(() => {
      history.push("/signin");
    });
  }

  // useEffect(() => {
  //   console.log(user);
  // },[user])


  return(
    <div className="header-bar">
      <div className="w-full d-flex space-between p-b-14 p-l-14 p-r-14" style={{borderBottom:"1px solid #FFFFFF"}}>
        <div className="flex-item header-logo bg-white d-flex">
          <img className="flex-item margin-auto" src={window.innerWidth > 767 ? GymshimLogoFull : client.logoIcon} alt="Gymshim Logo" />
        </div>
        {
          props.gyms!=false && (
          props.dataType == "brands" ? (
            <BrandFilter getSelectedBrand={handleSelectedBrand} />
          ) : (
            <GymFilter getSelectedGym={handleSelectedGym} />
          )
        )
        }
        {/* <div className="select-gym flex-item d-flex">
          <div className="flex-item d-flex margin-auto">
            <p className="flex-item m-r-4 font-weight-700 color-dark-blue fs-16">Urbounce Baner</p>
            <svg className="flex-item" width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7.04883 10L12.0488 15L17.0488 10" stroke="#6D6D6D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
        </div> */}
        <div onClick={()=>toggleProfileView()} className="flex-item user-profile-btn" style={{position:"relative"}}>
          {
            !user.profileID ? (
              <svg width="100%" height="100%" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M40 20C40 31.046 31.046 40 20 40C8.954 40 0 31.046 0 20C0 8.954 8.954 0 20 0C31.046 0 40 8.954 40 20ZM26 14C26 15.5913 25.3679 17.1174 24.2426 18.2426C23.1174 19.3679 21.5913 20 20 20C18.4087 20 16.8826 19.3679 15.7574 18.2426C14.6321 17.1174 14 15.5913 14 14C14 12.4087 14.6321 10.8826 15.7574 9.7574C16.8826 8.6321 18.4087 8 20 8C21.5913 8 23.1174 8.6321 24.2426 9.7574C25.3679 10.8826 26 12.4087 26 14ZM20 37C23.4326 37.0055 26.7856 35.9669 29.614 34.022C30.822 33.192 31.338 31.612 30.634 30.326C29.18 27.66 26.18 26 20 26C13.82 26 10.82 27.66 9.364 30.326C8.662 31.612 9.178 33.192 10.386 34.022C13.2144 35.9669 16.5674 37.0055 20 37Z" fill="#9A9A9A"/>
              </svg>
            ) : (
              <img className="flex-item" src={`${client.config.API_URL}${client.config.prefixStream}/media/file/${user.profileID}?${Date.now()}`} />
            )
          }
          <div className="dropdown-indicator d-flex" style={{transition:"220ms", transform: isProfileViewOpen ? "rotate(180deg)" : "rotate(0deg)"}}>
            <svg className="flex-item margin-auto m-t-2" width="8" height="8" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 0.5L5 4.5L9 0.5" stroke="#C1E8FC" stroke-linecap="round"/>
            </svg>
          </div>

          {
            isProfileViewOpen && (
              <div className="mobile-profile-view slideTopToBottom">
                <div className="d-flex">
                  <div className="mobile-user-profile margin-auto">
                    {
                      !user.profileID ? (
                        <svg className="flex-item" width="100%" height="100%" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M40 20C40 31.046 31.046 40 20 40C8.954 40 0 31.046 0 20C0 8.954 8.954 0 20 0C31.046 0 40 8.954 40 20ZM26 14C26 15.5913 25.3679 17.1174 24.2426 18.2426C23.1174 19.3679 21.5913 20 20 20C18.4087 20 16.8826 19.3679 15.7574 18.2426C14.6321 17.1174 14 15.5913 14 14C14 12.4087 14.6321 10.8826 15.7574 9.7574C16.8826 8.6321 18.4087 8 20 8C21.5913 8 23.1174 8.6321 24.2426 9.7574C25.3679 10.8826 26 12.4087 26 14ZM20 37C23.4326 37.0055 26.7856 35.9669 29.614 34.022C30.822 33.192 31.338 31.612 30.634 30.326C29.18 27.66 26.18 26 20 26C13.82 26 10.82 27.66 9.364 30.326C8.662 31.612 9.178 33.192 10.386 34.022C13.2144 35.9669 16.5674 37.0055 20 37Z" fill="#9A9A9A"/>
                        </svg>
                      ) : (
                        <img className="flex-item" src={`${client.config.API_URL}${client.config.prefixStream}/media/file/${user.profileID}?${Date.now()}`} />
                      )
                    }
                  </div>                
                </div>
                <div className="d-flex m-t-12">
                  <p className="margin-auto fs-16 font-weight-700 color-black" style={{maxWidth:"60%", lineHeight:"16px"}}>{user.name}</p>
                </div>
                <div className="d-flex">
                  <p className="margin-auto fs-12 font-weight-400">{user.email?user.email : user.phone}</p>
                </div>
                <div className="d-flex m-t-20">
                  <div onClick={()=>handleSignOut()} className="d-flex flex-item margin-auto">
                    <p className="flex-item m-r-8 color-red font-weight-700">Sign Out</p>
                    <svg className="flex-item" width="14" height="14" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M2 18C1.45 18 0.979333 17.8043 0.588 17.413C0.196667 17.0217 0.000666667 16.5507 0 16V2C0 1.45 0.196 0.979333 0.588 0.588C0.98 0.196667 1.45067 0.000666667 2 0H8C8.28333 0 8.521 0.0960001 8.713 0.288C8.905 0.48 9.00067 0.717333 9 1C8.99933 1.28267 8.90333 1.52033 8.712 1.713C8.52067 1.90567 8.28333 2.00133 8 2H2V16H8C8.28333 16 8.521 16.096 8.713 16.288C8.905 16.48 9.00067 16.7173 9 17C8.99933 17.2827 8.90333 17.5203 8.712 17.713C8.52067 17.9057 8.28333 18.0013 8 18H2ZM14.175 10H7C6.71667 10 6.47933 9.904 6.288 9.712C6.09667 9.52 6.00067 9.28267 6 9C5.99933 8.71733 6.09533 8.48 6.288 8.288C6.48067 8.096 6.718 8 7 8H14.175L12.3 6.125C12.1167 5.94167 12.025 5.71667 12.025 5.45C12.025 5.18333 12.1167 4.95 12.3 4.75C12.4833 4.55 12.7167 4.44567 13 4.437C13.2833 4.42833 13.525 4.52433 13.725 4.725L17.3 8.3C17.5 8.5 17.6 8.73333 17.6 9C17.6 9.26667 17.5 9.5 17.3 9.7L13.725 13.275C13.525 13.475 13.2877 13.571 13.013 13.563C12.7383 13.555 12.5007 13.4507 12.3 13.25C12.1167 13.05 12.0293 12.8127 12.038 12.538C12.0467 12.2633 12.1423 12.034 12.325 11.85L14.175 10Z" fill="#E33A34"/>
                    </svg>
                  </div>
                </div>
              </div>
            )
          }
        </div>
      </div>
    </div>
  )
}


export default GlobalHeader;